import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilService, PaymentV2Service, EventsService, VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-sip-pitch-card-v2',
  templateUrl: './sip-pitch-card-v2.component.html',
  styleUrls: ['./sip-pitch-card-v2.component.scss']
})
export class SipPitchCardV2Component implements OnInit {

  @Input() config;
  lastOrder;

  infoText = [
    { text: 'Save 12 lives every year' },
    { text: 'Allocate funds to causes you prefer' },
    { text: 'Get regular updates about your impact' },
    { text: 'Unlock special rewards' }
  ];

  constructor(
    public util: UtilService,
    public paymentV2: PaymentV2Service,
    private events: EventsService,
    private vars: VariablesService,
    public vwo: VwoService,
    public actRout: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.pushEvent();
    this.vars.lastOrderInfo.subscribe(res => {
      if (res) {
        this.lastOrder = res;
        this.config.currency = this.config?.currency || this.lastOrder?.iso_currency;
      }
    });
  }

  pushEvent() {
    this.events.sendSystemEvent({
      eventName: 'update_sip_card',
      page_name: this.vars.pageName,
      info_3: this.vars.campaignType
    }).subscribe(_ => _);

  }

}
